import PropTypes from "prop-types";
import { Card, Col, Modal, Row } from "react-bootstrap";
import { COMPONENT_REGISTRY } from "../registry/componentRegistry";
import { getPreviewComponent, REALISTIC_IMAGE_MAP } from "../registry/componentPreviews";

/**
 * LiveComponentSelectModal – SCADA component picker.
 *
 * Renders high-fidelity 3D SCADA preview icons from the component registry.
 * Each component displays its actual realistic SCADA appearance.
 *
 * Excludes: junction, backward-compat aliases (pump/tank/valve)
 */

// Build display list from registry, excluding aliases and junction
const DISPLAY_TYPES = Object.keys(COMPONENT_REGISTRY).filter(
  (key) => !["pump", "tank", "valve", "splitAc", "junction"].includes(key)
);

const LiveComponentSelectModal = ({ show, onClose, onSelect }) => {
  const handleClose = () => {
    onClose();
  };

  const handleClick = (componentType) => {
    onClose();
    onSelect(componentType);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="fs-6">Add SCADA Component</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Row md={2} xs={1} className="g-3">
            {DISPLAY_TYPES.map((type) => {
              const meta = COMPONENT_REGISTRY[type];
              const PreviewSVG = getPreviewComponent(type);
              const realisticImg = REALISTIC_IMAGE_MAP[type];

              return (
                <Col key={type}>
                  <button className="btn w-100 p-0 border-0 bg-transparent text-start">
                    <Card
                      className="p-3 rounded-3 w-100 live-component-card"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleClick(type)}
                    >
                      <div className="d-flex align-items-center">
                        {/* 3D Realistic / SVG preview icon */}
                        <div
                          className="d-flex align-items-center justify-content-center flex-shrink-0"
                          style={{ width: 52, height: 52 }}
                        >
                          {realisticImg ? (
                            <img
                              src={realisticImg}
                              alt={meta.label}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                                filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.18))",
                              }}
                            />
                          ) : (
                            <PreviewSVG color={meta.color} size={42} />
                          )}
                        </div>
                        <div className="ps-3">
                          <Card.Title className="mb-1">{meta.label}</Card.Title>
                          <Card.Text className="text-muted small mb-0">
                            {meta.subtitle}
                          </Card.Text>
                        </div>
                      </div>
                    </Card>
                  </button>
                </Col>
              );
            })}
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

LiveComponentSelectModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default LiveComponentSelectModal;
